<template>
  <div>
    <p>
      Please indicate the extent to which you agree with the following
      statements:
    </p>
    <v-form @input="formInput">
      <div v-for="(rq, index) in ratingQuestions" :key="index">
        <strong>{{ rq.title }}</strong>
        <v-radio-group
          v-model="rq.response"
          hide-details=""
          class="mt-0 mb-5"
          :rules="requiredRules"
        >
          <v-radio label="Strongly agree" value="stronglyAgree"></v-radio>
          <v-radio label="Agree" value="agree"></v-radio>
          <v-radio label="Somewhat agree" value="somewhatAgree"></v-radio>
          <v-radio label="Neither agree or disagree" value="neither"></v-radio>
          <v-radio label="Somewhat disagree" value="somewhatDisagree"></v-radio>
          <v-radio label="Disagree" value="disagree"></v-radio>
          <v-radio label="Strongly disagree" value="stronglyDisagree"></v-radio>
        </v-radio-group>
      </div>
      <strong>How old do you perceive this speaker to be? </strong>
      <v-slider
        class="mt-10 mb-4"
        v-model="age"
        color="blue"
        track-color="blue"
        hide-details
        thumb-label="always"
        min="18"
        max="85"
      >
        <template v-slot:prepend> 18 </template>
        <template v-slot:append> 85 </template>
      </v-slider>
      <strong>What gender do you perceive this speaker to be?</strong>
      <v-radio-group
        v-model="gender"
        hide-details=""
        class="mt-0 mb-4"
        :rules="requiredRules"
      >
        <v-radio label="Woman" value="woman"></v-radio>
        <v-radio label="Man" value="man"></v-radio>
        <v-radio label="Non-binary" value="nonBinary"></v-radio>
        <v-radio
          label="Another gender (please specify)"
          value="other"
        ></v-radio>
        <v-text-field
          v-model="genderOther"
          v-if="gender == 'other'"
          filled
          dense
          placeholder="Please specify"
        ></v-text-field>
      </v-radio-group>

      <strong>How feminine do you perceive this speaker to be?</strong>
      <v-col class="mt-0 mb-5 pt-0">
        <v-row align="end">
          Not at all feminine
          <v-radio-group
            v-model="feminine"
            hide-details=""
            row
            :rules="requiredRules"
          >
            <v-radio label="1" value="1"></v-radio>
            <v-radio label="2" value="2"></v-radio>
            <v-radio label="3" value="3"></v-radio>
            <v-radio label="4" value="4"></v-radio>
            <v-radio label="5" value="5"></v-radio>
            <v-radio label="6" value="6"></v-radio>
            <v-radio label="7" value="7"></v-radio>
          </v-radio-group>
          Very feminine
        </v-row>
      </v-col>

      <strong>How masculine do you perceive this speaker to be?</strong>
      <v-col class="mt-0 mb-5 pt-0">
        <v-row align="end">
          Not at all masculine
          <v-radio-group
            v-model="masculine"
            hide-details=""
            row
            :rules="requiredRules"
          >
            <v-radio label="1" value="1"></v-radio>
            <v-radio label="2" value="2"></v-radio>
            <v-radio label="3" value="3"></v-radio>
            <v-radio label="4" value="4"></v-radio>
            <v-radio label="5" value="5"></v-radio>
            <v-radio label="6" value="6"></v-radio>
            <v-radio label="7" value="7"></v-radio>
          </v-radio-group>
          Very masculine
        </v-row>
      </v-col>

      <strong
        >What racial identity/ies do you perceive this speaker to have?</strong
      >
      <v-radio-group
        v-model="race"
        hide-details=""
        class="mt-0 mb-5"
        :rules="requiredRules"
      >
        <v-radio label="White or Caucasian" value="white"></v-radio>
        <v-radio label="Black or African American" value="black"></v-radio>
        <v-radio label="Asian" value="asian"></v-radio>
        <v-radio
          label="Native Hawaiian or Pacific Islander"
          value="nativeHawaiian"
        ></v-radio>
        <v-radio label="Latin@" value="latin"></v-radio>
        <v-radio label="Multiple racial categories" value="multiple"></v-radio>
        <v-radio label="Another racial category (please specify)" value="other"></v-radio>
        <v-text-field
          v-model="raceOther"
          v-if="race == 'other'"
          filled
          dense
          placeholder="Please specify"
        ></v-text-field>
      </v-radio-group>
    </v-form>
  </div>
</template>


<script>
import { ref } from "@vue/composition-api";
export default {
  props: ["value"],
  setup(props, context) {
    const speakerEvalForm = ref(null);
    const requiredRules = [(v) => !!v || "This field is required"];
    const formInput = (e) => {
      context.emit("input", e);
    };

    const ratingQuestions = ref([
      {
        key: "confident",
        title:
          "This speaker is confident in themselves and in what they're saying.",
      },
      {
        key: "forceful",
        title: "This speaker has a forceful or authoritative voice.",
      },
      { key: "arrogant", title: "This speaker sounds arrogant." },
      {
        key: "expert",
        title: "This speaker sounds like a trustworthy expert in this topic.",
      },
      {
        key: "engaging",
        title: "This speaker successfully engages their audience.",
      },
      {
        key: "immature",
        title: "This speaker sounds too immature to host this podcast.",
      },
      {
        key: "following",
        title: "This speaker is making sure their listeners can follow along.",
      },
      {
        key: "friends",
        title: "This speaker sounds like they have a lot friends.",
      },
      { key: "annoying", title: "This speaker sounds annoying to listen to." },
    ]);

    const age = ref(null);
    const gender = ref(null);
    const genderOther = ref(null);
    const feminine = ref(null);
    const masculine = ref(null);
    const race = ref(null);
    const raceOther = ref(null);

    return {
      speakerEvalForm,
      formInput,
      requiredRules,
      ratingQuestions,
      age,
      gender,
      genderOther,
      feminine,
      masculine,
      race,
      raceOther,
    };
  },
};
</script>